// whatsapp/SendOverviewPanel.jsx — جولة تصحيح 2026-10-14 (المرحلة 3) · البند 6.
// صفحة «الإرسال» للمالك: عرضان — حسب المُرسِل / حسب القالب.
import React, { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { ErrorCard } from "../components/ErrorCard";
import { formatKSA } from "../lib/ksaTime";
import CustomerListModal from "../components/CustomerListModal";

const fmtN = (n) => Number(n || 0).toLocaleString("ar");

const WINDOW_SINCE_MS = { today: 24 * 3600 * 1000, d7: 7 * 24 * 3600 * 1000, d30: 30 * 24 * 3600 * 1000 };

function windowDateFrom(w) {
  return new Date(Date.now() - WINDOW_SINCE_MS[w]).toISOString();
}

function SenderTable({ items, onOpenRecipients }) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }} data-testid="send-overview-sender-table">
        <thead>
          <tr style={{ background: "#F7F2EC", color: "#78716C" }}>
            <th style={{ padding: "8px 10px", textAlign: "right" }}>المُرسِل</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>الحالة</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>آخر تشغيل (KSA)</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>اليوم (وصل/قُرئ/فشل)</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>7 أيام</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>30 يوماً</th>
          </tr>
        </thead>
        <tbody>
          {items.map((s) => (
            <tr key={s.sender_key} data-testid={`send-overview-sender-row-${s.sender_key}`}
                style={{ borderTop: "1px solid rgba(61,42,28,0.08)" }}>
              <td style={{ padding: "8px 10px", fontWeight: 700 }}>{s.name_ar}</td>
              <td style={{ padding: "8px 10px", textAlign: "center", fontSize: 11 }}>{s.status_ar}</td>
              <td style={{ padding: "8px 10px", textAlign: "center", fontSize: 11 }}>
                {formatKSA(s.last_run_at)}
                {s.last_run_accepted === false && (
                  <div style={{ color: "#B91C1C", fontSize: 10 }}>آخر محاولة رُفضت: {s.last_run_reason}</div>
                )}
              </td>
              {["today", "d7", "d30"].map((w) => (
                <td key={w} style={{ padding: "8px 10px", textAlign: "center" }}>
                  <button type="button" data-testid={`send-overview-sender-${s.sender_key}-${w}`}
                    onClick={() => onOpenRecipients({ kind: "wa_sender_recipients", key: s.sender_key,
                      title: `مستلمو ${s.name_ar} (${w === "today" ? "اليوم" : w === "d7" ? "7 أيام" : "30 يوماً"})`,
                      dateFrom: windowDateFrom(w) })}
                    style={{ border: "none", background: "transparent", cursor: "pointer", color: "#92400E", fontWeight: 700, textDecoration: "underline" }}>
                    {fmtN(s.counts[w].sent)}
                  </button>
                  <div style={{ fontSize: 10, color: "#78716C" }}>
                    ✓✓{fmtN(s.counts[w].delivered)} · قُرئ {fmtN(s.counts[w].read)} ·
                    <span style={{ color: s.counts[w].failed ? "#B91C1C" : "#78716C" }}> فشل {fmtN(s.counts[w].failed)}</span>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function TemplateTable({ items, onOpenRecipients }) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }} data-testid="send-overview-template-table">
        <thead>
          <tr style={{ background: "#F7F2EC", color: "#78716C" }}>
            <th style={{ padding: "8px 10px", textAlign: "right" }}>القالب</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>الغرض</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>مستلمون فريدون</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>داخل/خارج قائمة الاختبار</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>أول إرسال</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>آخر إرسال</th>
            <th style={{ padding: "8px 10px", textAlign: "center" }}>المُرسِل(ون)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.template_name} data-testid={`send-overview-template-row-${t.template_name}`}
                style={{ borderTop: "1px solid rgba(61,42,28,0.08)" }}>
              <td style={{ padding: "8px 10px", fontWeight: 700, direction: "ltr", textAlign: "right" }}>{t.template_name}</td>
              <td style={{ padding: "8px 10px", textAlign: "center" }}>
                {t.send_purpose === "customer"
                  ? <span style={{ color: "#166534", fontWeight: 700 }}>✓ عميل</span>
                  : t.send_purpose === "test"
                    ? <span style={{ color: "#B45309", fontWeight: 700 }}>🧪 اختباري</span>
                    : <span style={{ color: "#B91C1C", fontWeight: 700 }}>⚠️ غير مصنَّف</span>}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "center" }}>
                <button type="button" data-testid={`send-overview-template-${t.template_name}-recipients`}
                  onClick={() => onOpenRecipients({ kind: "wa_template_recipients", key: t.template_name,
                    title: `مستلمو قالب ${t.template_name}`,
                    dateFrom: t.first_send || "2020-01-01T00:00:00+00:00" })}
                  style={{ border: "none", background: "transparent", cursor: "pointer", color: "#92400E", fontWeight: 700, textDecoration: "underline" }}>
                  {fmtN(t.unique_recipients_count)}
                </button>
              </td>
              <td style={{ padding: "8px 10px", textAlign: "center", fontSize: 11 }}>
                {fmtN(t.in_test_list_count)} / {fmtN(t.outside_test_list_count)}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "center", fontSize: 11 }}>{formatKSA(t.first_send)}</td>
              <td style={{ padding: "8px 10px", textAlign: "center", fontSize: 11 }}>{formatKSA(t.last_send)}</td>
              <td style={{ padding: "8px 10px", textAlign: "center", fontSize: 10.5 }}>{(t.senders || []).join("، ") || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function SendOverviewPanel() {
  const [tab, setTab] = useState("sender");
  const [senderData, setSenderData] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    let endpoint = "/whatsapp/send-overview/by-sender";
    try {
      const [s, t] = await Promise.all([
        api.get(endpoint),
        api.get("/whatsapp/send-overview/by-template").catch((e) => {
          endpoint = "/whatsapp/send-overview/by-template"; throw e; }),
      ]);
      setSenderData(s.data);
      setTemplateData(t.data);
    } catch (e) {
      setError({ endpoint, code: e?.response?.status ?? e?.code ?? "شبكة" });
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="wa-send-overview-panel">
      <div className="card" style={{ padding: 12, marginBottom: 10 }}>
        <div style={{ fontSize: 12.5, fontWeight: 800, color: "var(--brown-deep)", marginBottom: 8 }}>
          📨 الإرسال — كل مُرسِل والقوالب المُستخدَمة
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <button type="button" data-testid="send-overview-tab-sender"
            onClick={() => setTab("sender")}
            style={{ padding: "6px 14px", borderRadius: 999, fontSize: 12, fontWeight: 700, cursor: "pointer",
                     border: tab === "sender" ? "1.5px solid var(--brown-deep)" : "1px solid var(--border)",
                     background: tab === "sender" ? "var(--brown-deep)" : "#fff",
                     color: tab === "sender" ? "#fff" : "var(--muted)" }}>
            حسب المُرسِل
          </button>
          <button type="button" data-testid="send-overview-tab-template"
            onClick={() => setTab("template")}
            style={{ padding: "6px 14px", borderRadius: 999, fontSize: 12, fontWeight: 700, cursor: "pointer",
                     border: tab === "template" ? "1.5px solid var(--brown-deep)" : "1px solid var(--border)",
                     background: tab === "template" ? "var(--brown-deep)" : "#fff",
                     color: tab === "template" ? "#fff" : "var(--muted)" }}>
            حسب القالب
          </button>
        </div>
      </div>

      {error && (
        <ErrorCard testId="send-overview-error" endpoint={error.endpoint} code={error.code}
          onRetry={load} retrying={loading} />
      )}
      {loading && !error && <div className="card" style={{ padding: 20, textAlign: "center" }}>⏳ جارٍ التحميل…</div>}

      {!loading && !error && tab === "sender" && senderData && (
        <SenderTable items={senderData.items || []}
          onOpenRecipients={(m) => setModal(m)} />
      )}
      {!loading && !error && tab === "template" && templateData && (
        <TemplateTable items={templateData.items || []}
          onOpenRecipients={(m) => setModal(m)} />
      )}

      {modal && (
        <CustomerListModal
          kind={modal.kind}
          segmentCode={modal.key}
          title={modal.title}
          dateFrom={modal.dateFrom}
          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}
